var map = {
	"./browser-notice.de-CH.json": 1005,
	"./browser-notice.de-DE.json": 1006,
	"./browser-notice.en-CA.json": 1007,
	"./browser-notice.en-GB.json": 1008,
	"./browser-notice.en-IN.json": 1009,
	"./browser-notice.en-ME.json": 1010,
	"./browser-notice.en-US.json": 1011,
	"./browser-notice.es-EM.json": 1012,
	"./browser-notice.es-ES.json": 1013,
	"./browser-notice.fr-BE.json": 1014,
	"./browser-notice.fr-CA.json": 1015,
	"./browser-notice.fr-CH.json": 1016,
	"./browser-notice.nl-BE.json": 1017,
	"./browser-notice.nl-NL.json": 1018,
	"./browser-notice.pl-PL.json": 1019,
	"./browser-notice.pt-BR.json": 1020
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1004;